import 'select2'
import 'select2/dist/css/select2.css'
export default class InviteUserShare {
  customOptionCompanyType($select) {
    const $dropdown = $select.data('select2').$dropdown;
    const $search = $dropdown.find('.select2-search--dropdown');

    $dropdown
      .find('.select2-dropdown--below')
      .addClass('company-type-select2');

    if ($search.length && !$dropdown.find('.select2-custom-header').length) {
      $search.replaceWith(`
        <span class="select2-custom-header">
          下記より取引種類を選択してください。
        </span>
      `);
    }
  }

  disableInvitedUserOptions(selectSelector) {
    const $select = $(selectSelector);
    if($("#assignAkairePopup").length > 0) {
      return;
    }
    $('[is-new-add="true"]').each(function () {
      const userId = $(this).find('input').data('user-id');

      if (!userId) return;
      const $option = $select.find(`option[value="${userId}"]`);

      if (!$option.length) return;
      $option.prop('disabled', true);
      const suffix = '（選択済み）';
      const text = $option.text();
      if (!text.includes(suffix)) {
        $option.text(text + suffix);
      }
    });
  }

  insertButtonToCompanySelect($select) {
    const isHidden = $('#button_add_new_by_email').hasClass('d-none')
    InviteUserShare.insertExternalButtonToSelect2($select, '#button_add_new_by_email', '.invite-by-email-button', isHidden);
  }

  insertButtonToMemberSelect($select) {
    const isHidden = $('#button_add_new_member').hasClass('d-none') && $('#button_add_member_of_partner').hasClass('d-none');
    InviteUserShare.insertExternalButtonToSelect2($select, '#button_add_new_member', '.invite-by-email-button', isHidden);
    InviteUserShare.insertExternalButtonToSelect2($select, '#button_add_member_of_partner', '.invite-member-of-partner-button', isHidden)
  }

  static insertExternalButtonToSelect2($select, buttonWrapper, buttonSelector, isHidden) {
    const $externalBtn = $(buttonWrapper).find(buttonSelector);
    const $dropdown = $select.data('select2').$dropdown;
    const $searchContainer = $dropdown.find('.select2-search--dropdown');

    if (!$(buttonWrapper).hasClass('d-none')) {
      if ($searchContainer.find(buttonSelector).length > 0) return;

      const $btn = $externalBtn.clone(false).addClass('select2-custom-btn')
      $searchContainer.append($btn);

    } else {
      if ($searchContainer.find(buttonSelector).length === 0) return;

      $searchContainer.find(buttonSelector).remove();
    }

    $searchContainer.css(
      'margin-right',
      isHidden ? '8px' : '40px'
    );
  }

  removeCompanyPrefixSuffix(data, placeholder) {
    if (!data.id) return placeholder;
    let text = data.text;
    text = text.replace(/^・/, '').replace(/（.*?）$/, '').trim();

    return text;
  }

  formatCompanyOptionWithIcon(data) {
    if (!data.id || !data.element) return data.text;
    const isTeam = data.element.dataset.type === 'owners';
    const name = data.text.replace(/^\u30fb/, '').replace(/\uff08.*?\uff09$/, '').trim();
    const color = isTeam ? '#E24B4A' : '#888780';
    const $opt = $('<span style="display:flex;align-items:center;gap:6px;max-width:100%;"></span>');
    $opt.append('<span style="display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;min-width:20px;border-radius:50%;background:' + color + ';"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M5 21v-1a7 7 0 0 1 14 0v1"/></svg></span>');
    $opt.append($('<span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;flex:1;text-align:left;"></span>').text(name));
    return $opt;
  }

  getCompanyType(element = null) {
    const localScope = element ? $(element).parent() : null;

    let company_type =
      localScope?.find('#js_select_company_type_task').val() ||
      localScope?.find('#js_select_company_invites_task option:selected').data('type');

    if (!company_type) {
      company_type =
        $('#js_select_company_type_task').val() ||
        $('#js_select_company_invites_task option:selected').data('type');
    }

    company_type = company_type || 'owners';

    return company_type;
  }

  updateCompanyTypeText(companyType) {
    const type_text = {
      owners: { type: 'owner', text: 'チーム' },
      suppliers: { type: 'supplier', text: '仕入先' },
      clients: { type: 'client', text: '販売先' },
      collaborators: { type: 'collaborator', text: '外部' }
    };
    if (type_text[companyType]) {
      $('.company-type-text').text(type_text[companyType].text);
    }
  }
}
